import { Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  deleteAgent,
  getAllAgents,
  updateAgent,
} from "../../../services/AgentApi";
import {
  decryptPassword,
  handleApiCall,
  handleOpenSnackBar,
} from "../../../utils/helper";
import { deleteAlert } from "../../../components/alerts";
import AppHeader from "../../../components/header";
import AppLoader from "../../../components/loader";
import SearchTab from "./SearchTab";
import DynamicTable from "../../../components/dynamicTable";
import AddEditAgentDialog from "./AddEditAgentDialog";
import PasswordDialog from "./PasswordDialog";
import { useNavigate } from "react-router-dom";

const tableHeader = [
  "Agent Details",
  "User ID",
  "Password",
  "Designation",
  "Calendar",
  "Status",
  "Preview",
  "Actions",
];

const displayRows = [
  "agent_details",
  "agent_email",
  "agent_password",
  "designation",
  "agent_calendar",
  "custom_status",
  "can_preview",
  "actions",
];

const AgentsPage = () => {
  const navigate = useNavigate();
  const openDialogRef = useRef(null);
  const openPasswordDialogRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allAgents, setAllAgents] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    handleFetchAllGents();
  }, []);

  const handleFetchAllGents = async () => {
    try {
      setIsLoading(true);
      const response = await getAllAgents();
      if (response?.data.status === "success") {
        let data = response.data.data;
        setAllAgents(data);
        setFilterData(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterByNameIdEmail = (e) => {
    setSearchValue(e.target.value);
    const filtered = allAgents.filter((itemm) => {
      return (
        itemm._id.toLowerCase().includes(e.target.value.toLowerCase()) ||
        itemm.username.toLowerCase().includes(e.target.value.toLowerCase()) ||
        itemm.email.toLowerCase().includes(e.target.value.toLowerCase())
      );
    });
    setFilterData(filtered);
  };

  // open add dialog

  const handleOpenAddDialog = () => {
    openDialogRef.current.isVisible({
      type: "add",
      data: null,
      getData: handleFetchAllGents,
    });
  };

  const handleEditData = (row) => {
    openDialogRef.current.isVisible({
      type: "edit",
      data: row,
      getData: handleFetchAllGents,
    });
  };

  const handleDeleteAgent = (row) => {
    deleteAlert(true, row._id, deleteAgent, handleFetchAllGents);
  };

  const handleShowPassword = (row) => {
    openPasswordDialogRef.current.isVisible({
      password: decryptPassword(row?.encrypted),
    });
  };

  const handleUpateAdminStatus = async (row, e) => {
    handleApiCall(
      row._id,
      updateAgent,
      { status: e },
      setIsLoading,
      () => {},
      handleFetchAllGents
    );
  };

  const handleAllowToPreview = async (row, e) => {
    handleApiCall(
      row._id,
      updateAgent,
      { canPreview: e },
      setIsLoading,
      () => {},
      handleFetchAllGents
    );
  };

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading} />
      <Stack mb={3}>
        <Typography
          variant="primaryText"
          component={"h1"}
          fontSize={{ xs: "1.5rem", md: "2.125rem" }}
        >
          List Of All Agents
        </Typography>
        <Typography variant="secondaryText" component={"p"}>
          You can add and edit agents
        </Typography>
      </Stack>

      <SearchTab
        handleOpenAddDialog={handleOpenAddDialog}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        tableData={allAgents}
        handleFilterData={handleFilterByNameIdEmail}
      />

      {allAgents?.length > 0 && (
        <>
          {/* Dynamic Table */}
          <DynamicTable
            tableData={filterData || []}
            displayRows={displayRows}
            tableHeader={tableHeader}
            showDelete
            showEdit
            handleDelete={handleDeleteAgent}
            handleShowPassword={handleShowPassword}
            handleLoginAs={() => alert("login As")}
            handleEdit={handleEditData}
            handleChangeCustomStatus={handleUpateAdminStatus}
            onNaviagteAgentsCalendarPage={(row, index) =>
              navigate(`/agent-calendar/${row._id}`)
            }
            handleAllowToPreview={handleAllowToPreview}
          />
        </>
      )}

      {/* Add edit dialog */}
      <AddEditAgentDialog ref={openDialogRef} />
      <PasswordDialog ref={openPasswordDialogRef} />
    </AppHeader>
  );
};

export default AgentsPage;
